function ok() { return { ok: true }; }
function fail(field, message) {
    return { ok: false, errors: [{ field, message }] };
}
function predicateMatches(input, p) {
    const s = input === null || input === undefined ? '' : String(input);
    switch (p.op) {
        case 'eq': return s === (p.value ?? '');
        case 'neq': return s !== (p.value ?? '');
        case 'gt': return Number(s) > Number(p.value);
        case 'lt': return Number(s) < Number(p.value);
        case 'empty': return s.length === 0 || s.trim().length === 0;
    }
}
const conditional = {
    id: 'conditional',
    family: 'logic',
    label: 'If / then / else',
    description: 'Output one literal when a predicate matches, another when it does not.',
    defaultConfig: { predicate: { op: 'eq', value: '' }, then: '' },
    evaluate: (input, config) => {
        const c = config;
        if (predicateMatches(input, c.predicate))
            return c.then;
        if (c.else !== undefined)
            return c.else;
        // passthrough
        return input === null || input === undefined ? '' : String(input);
    },
    validate: (config) => {
        const c = config;
        if (!c.predicate?.op)
            return fail('predicate', 'predicate.op is required');
        if (!['eq', 'neq', 'gt', 'lt', 'empty'].includes(c.predicate.op))
            return fail('predicate', 'predicate.op must be eq/neq/gt/lt/empty');
        if (typeof c.then !== 'string')
            return fail('then', 'then is required');
        return ok();
    },
    formSchema: [
        { key: 'predicate', label: 'If…', type: 'condition', required: true },
        { key: 'then', label: 'Then output', type: 'text', required: true },
        { key: 'else', label: 'Else output (optional — defaults to passthrough)', type: 'text' },
    ],
    sampleSeeds: ['A', '5', ''],
};
export const logicOps = [conditional];
//# sourceMappingURL=logic-ops.js.map